import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem, shadowDown } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const headerWrapper = css`
  background-color: var(--brand-purple-10);

  &[data-success='true'] {
    background-color: var(--tertiary-green-50);
  }

  display: flex;
  ${
    /* flex shorthand line below needed to fix height not being correctly worked out with nested flex containers on safari mobile */ ''
  }
  flex: 0 0 auto;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${spacing.md}px;
  ${shadowDown}

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      border-radius: ${pxToRem(10)} ${pxToRem(10)} 0 0;
    `,
  )}
`;

export const stacked = css`
  flex-direction: column;
  flex-flow: column-reverse;
  padding: ${spacing.md}px ${spacing.md}px ${spacing.xl}px;

  [aria-label='Close dialog'] {
    align-self: flex-end;
  }
`;
